import React, { useEffect, useRef, useState } from 'react';
import { MultiValue, SingleValue } from 'react-select';
import { useSelector } from 'react-redux';
import {
  createSearchParams,
  URLSearchParamsInit,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { SelectOption } from 'components/shared/forms/AutocompleteSelect/AutocompleteSelect';
import DropdownSelect from 'components/shared/forms/DropdownSelect';
import { ITimeAndActivityReportsURLSearchParams } from 'features/timeAndActivityReports/timeAndActivityReportsTypes';
import { projectsFilterListSelector } from 'features/projectsFilterList/projectsFilterListSlice';

const ProjectsFilter = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const projects = useSelector(projectsFilterListSelector);
  const isMountedRef = useRef(false);

  const projectsQuery = searchParams.getAll('projectsIds');

  const projectsFromQueries = projects.filter((project) =>
    projectsQuery.includes(String(project.id))
  );
  const allProjectsOptions = projects.map((project) => ({
    label: project.name,
    value: String(project.id),
  }));

  const [projectsOptions, setProjectsOptions] =
    useState<MultiValue<SelectOption> | null>(null);

  const handleProjectsOptionsChange = (
    option: SingleValue<SelectOption> | MultiValue<SelectOption>
  ) => {
    setProjectsOptions(option as MultiValue<SelectOption>);
  };

  useEffect(() => {
    if (projectsFromQueries && projectsFromQueries.length > 0) {
      setProjectsOptions(
        projectsFromQueries.map((project) => ({
          label: project.name,
          value: String(project.id),
        }))
      );
    }
  }, [projects]);

  useEffect(() => {
    if (isMountedRef.current) {
      const params = Object.fromEntries([...Array.from(searchParams)]);
      const URLSearchParams: ITimeAndActivityReportsURLSearchParams = {
        ...params,
        columns: searchParams.getAll('columns'),
        clientsIds: searchParams.getAll('clientsIds'),
        membersIds: searchParams.getAll('membersIds'),
      };

      if (projectsOptions && projectsOptions.length > 0) {
        URLSearchParams.projectsIds = projectsOptions.map(
          (option) => option.value
        );
      } else {
        delete URLSearchParams.projectsIds;
      }

      navigate({
        pathname: pathname,
        search: createSearchParams(
          URLSearchParams as URLSearchParamsInit
        ).toString(),
      });
    }
    isMountedRef.current = true;
  }, [projectsOptions]);

  return (
    <>
      <DropdownSelect
        label="Projects"
        value={projectsOptions}
        options={allProjectsOptions}
        onChange={(value) => {
          handleProjectsOptionsChange(value);
        }}
        isSearchable
        blurInputOnSelect={false}
        isMulti
      />
    </>
  );
};

export default ProjectsFilter;
